/**
 * zyICode and zyInlineCode behaviour
 * based on servers/zyauthor-server/app/logic/legacy_zyauthor/parser.py
 * CSS white-space matrix:
 *   preserveWhitespace | allowWrap | value
 *   false               | false     | 'nowrap'   (default: collapse spaces, no wrap)
 *   true                | false     | 'pre'      (preserve spaces, no wrap)
 *   true                | true      | 'pre-wrap' (preserve spaces, wrap)
 *   false               | true      | null       (collapse spaces, browser default wrap)
 */
export type WhitespaceValue = 'pre-wrap' | 'pre' | 'nowrap' | null;

/** Converts preserveWhitespace + allowWrap booleans to a CSS white-space value. */
export function toWhitespaceCss(preserveWhitespace: boolean, allowWrap: boolean): WhitespaceValue {
    if (preserveWhitespace && allowWrap) return 'pre-wrap';
    if (preserveWhitespace) return 'pre';
    if (allowWrap) return null;
    return 'nowrap';
}

/** Parses a CSS white-space value (or legacy string) into preserveWhitespace + allowWrap. */
export function fromWhitespaceCss(value: WhitespaceValue | string | null | undefined): { preserveWhitespace: boolean; allowWrap: boolean } {
    if (value === undefined || value === '') {
        return { preserveWhitespace: false, allowWrap: true };
    }
    const v = value === 'pre-wrap' || value === 'pre' || value === 'nowrap' ? value : null;
    switch (v) {
        case 'pre-wrap':
            return { preserveWhitespace: true, allowWrap: true };
        case 'pre':
            return { preserveWhitespace: true, allowWrap: false };
        case 'nowrap':
            return { preserveWhitespace: false, allowWrap: false };
        case null:
            return { preserveWhitespace: false, allowWrap: true };
        default:
            return { preserveWhitespace: false, allowWrap: true };
    }
}
